/* eslint-disable react/no-unescaped-entities */
import { useState } from "react";
import { Link, Navigate, useNavigate } from "react-router-dom";
import { Loader2 } from "lucide-react";
import { toast } from "sonner";
import { useCustomerAuth, describeAxiosError, formatApiError } from "@/contexts/CustomerAuthContext";
import AuthShell, { Field } from "@/components/customer/AuthShell";
import SEO from "@/components/site/SEO";

export default function Login() {
  const { user, login } = useCustomerAuth();
  const nav = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  if (user && user !== false) return <Navigate to="/app" replace />;

  const onSubmit = async (e) => {
    e.preventDefault();
    setError(""); setLoading(true);
    try {
      await login(email.trim().toLowerCase(), password);
      nav("/app", { replace: true });
    } catch (err) {
      const msg = describeAxiosError(err, "Login failed.");
      setError(msg); toast.error(msg);
    } finally { setLoading(false); }
  };

  return (
    <AuthShell eyebrow="Welcome back" title="Sign in"
      subtitle="Use your OneDial Africa email and password."
      footer={<>New here? <Link to="/register" className="font-semibold text-brand-green hover:text-brand-greenHover">Create an account</Link></>}>
      <SEO title="Sign in" path="/login" />
      <form onSubmit={onSubmit} className="space-y-5" data-testid="login-form" noValidate>
        <Field label="Email" type="email" testId="login-email" value={email} onChange={(e)=>setEmail(e.target.value)}
               placeholder="you@example.com" required autoComplete="email" name="email" />
        <Field label="Password" type="password" testId="login-password" value={password} onChange={(e)=>setPassword(e.target.value)}
               placeholder="••••••••••••" required autoComplete="current-password" name="password" />
        {error && <div data-testid="login-error" className="rounded-md border border-red-200 bg-red-50 text-red-700 text-sm px-3 py-2">{error}</div>}
        <div className="flex items-center justify-between text-sm">
          <span />
          <Link to="/forgot-password" className="text-brand-green font-semibold hover:text-brand-greenHover">Forgot password?</Link>
        </div>
        <button type="submit" disabled={loading} data-testid="login-submit"
                className="w-full inline-flex items-center justify-center gap-2 rounded-full bg-brand-green px-6 py-3 text-sm font-semibold text-brand-ink hover:bg-brand-greenHover disabled:opacity-70">
          {loading ? <><Loader2 className="h-4 w-4 animate-spin" /> Signing in…</> : "Sign in"}
        </button>
      </form>
    </AuthShell>
  );
}
